module.exports = __webpack_public_path__ + "img/Anhänger_SwPu_5000.edb3c384.svg";